/* eslint-disable @typescript-eslint/no-inferrable-types */
export const textoParaValor = (valor: string) => {
  const numero = valor.replace(/\D/g, '');

  return parseFloat(numero) / 100;
};

export const valorParaTexto = (valor?: number | string, obrigatorio: boolean = false): string => {
  if (valor === null || valor === undefined || isNaN(Number(valor))) {
    return obrigatorio
      ? (0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : '';
  }

  // Garante que o valor seja tratado como número
  const numericValue = typeof valor === 'string' ? parseFloat(valor) : valor;

  return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const retornarImagemBanco = (banco?: string) => {
  switch (banco) {
  }
};

export const retornarImagemBandeira = (bandeira?: string) => {
  switch (bandeira) {
  }
};

export const primeiroDiaMesAtual = () => {
  const data = new Date();
  return new Date(data.getFullYear(), data.getMonth(), 1);
};

export const ultimoDiaMesAtual = () => {
  const data = new Date();
  return new Date(data.getFullYear(), data.getMonth() + 1, 0);
};

export const extrairMesAno = (data: Date) => {
  const mes = data.getMonth() + 1;
  const ano = data.getFullYear();

  return `${ano}-${mes.toString().padStart(2, '0')}`;
};


/**
 * Pagamento de fatura de cartão: é QUITAÇÃO das compras (já contadas uma a uma),
 * nunca um gasto novo — senão o mês dobraria. Sai da conta de origem (aparece na
 * movimentação da conta), mas fica FORA de toda análise de despesas.
 */
export const PAGAMENTO_FATURA = 'Pagamento de fatura';

export const ehPagamentoFatura = (t: { tipoPagamento?: string }) => t.tipoPagamento === PAGAMENTO_FATURA;

/**
 * Transferência entre contas próprias: o MESMO dinheiro mudando de bolso.
 * Vira um par de transações (D na origem, R no destino) com este tipoPagamento;
 * conta no saldo/movimentação de cada conta, mas NUNCA em receitas/despesas
 * das análises — senão todo aporte pra poupança viraria "gasto" e "renda".
 */
export const TRANSFERENCIA_CONTAS = 'Transferência entre contas';

export const ehTransferenciaEntreContas = (t: { tipoPagamento?: string }) =>
  t.tipoPagamento === TRANSFERENCIA_CONTAS;

/**
 * Saldo inicial da conta: CONFIGURAÇÃO, não renda/gasto. Conta apenas no saldo
 * consolidado da conta — fora de receitas/despesas, análises e "movimento do mês".
 */
export const SALDO_INICIAL = 'Saldo inicial';

export const ehSaldoInicial = (t: { tipoPagamento?: string }) => t.tipoPagamento === SALDO_INICIAL;

/** Entrada interna (transferência recebida ou saldo inicial): não é receita. */
export const ehEntradaInterna = (t: { tipoPagamento?: string }) =>
  ehTransferenciaEntreContas(t) || ehSaldoInicial(t);

/** Movimento interno (quitação, transferência ou saldo inicial): fora de TODA análise. */
export const ehMovimentoInterno = (t: { tipoPagamento?: string }) =>
  ehPagamentoFatura(t) || ehTransferenciaEntreContas(t) || ehSaldoInicial(t);

/** Extrai a mensagem de erro vinda da API (axios), sem 'any' espalhado nos serviços. */
export const mensagemDeErro = (err: unknown): string | undefined => {
  const e = err as { response?: { data?: { message?: string; detail?: string } } };
  return e?.response?.data?.message ?? e?.response?.data?.detail;
};
